import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ComponentService } from "../../../services/component.service";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { LoginComponent } from "../../login";
let WhitelistAddressApprovedModalComponent = class WhitelistAddressApprovedModalComponent {
    constructor(sanitizer, router, compService, location, httpClient, themeService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.compService = compService;
        this.location = location;
        this.httpClient = httpClient;
        this.themeService = themeService;
        this.secondColor = '';
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    continueWithdrawal() {
        if (this.user) {
            this.close();
            this.router.navigate(['/wallet/cryptocurrencies'], { state: { redirect: this.router.url } });
        }
        else {
            this.close();
            this.compService.openModal(LoginComponent);
        }
    }
};
WhitelistAddressApprovedModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: SharedHttp },
    { type: WebsiteThemeService }
];
WhitelistAddressApprovedModalComponent = __decorate([
    Component({
        selector: 'ecd-whitelist-address-approved-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./whitelist-address-approved-modal.component.html")).default,
    })
], WhitelistAddressApprovedModalComponent);
export { WhitelistAddressApprovedModalComponent };
